interface FormInputProps {
  label: string
  type: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  required?: boolean
}

export default function FormInput({ label, type, value, onChange, placeholder, required }: FormInputProps) {
  return (
    <div>
      <label className="block text-sm text-ink-muted mb-1.5">{label}</label>
      <input
        type={type}
        required={required}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={placeholder}
        className="w-full bg-paper border border-line rounded-lg px-3 py-2.5 text-ink text-sm placeholder:text-ink-faint focus:outline-none focus:border-base-500 focus:ring-1 focus:ring-base-500 transition-colors"
      />
    </div>
  )
}
